import React, { useEffect, useState } from "react";
import { CircularProgress, Stack } from "@mui/material";
import useStyles from "./styles";
import { color } from "../../../config/theme";
import { getApiData } from "../../../utils/APIHelper";
import { Setting } from "../../../utils/Setting";
import ChangeRequestList from "./components/ChangeRequestList";
import { useSearchParams } from "react-router-dom";
import ChangeRequestTabs from "./components/ChangeRequestTabs";

const Changelog = ({ projectId, projectDetails }) => {
  const [changelogs, setChangelogs] = useState([]);
  const [loading, setLoading] = useState();
  const classes = useStyles();
  let [searchParams] = useSearchParams();

  const changeId = searchParams.get("change");

  const getChangelogItems = async () => {
    try {
      setLoading(true);
      const response = await getApiData(
        Setting.endpoints.changeRequest.list(projectId),
        "GET",
        {},
        {},
        false
      );
      // Node CR list response: { success, data: { items: [...], total_count, ... } }.
      // Legacy Java response was a plain array OR { items: [...] } at the root.
      // Unwrap data.items first, then fall back to the older shapes.
      const items = Array.isArray(response?.data?.items)
        ? response.data.items
        : Array.isArray(response?.items)
        ? response.items
        : Array.isArray(response)
        ? response
        : [];
      setChangelogs(items);
    } catch (error) {
      console.log("error in change log list", error);
      setChangelogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (projectId) {
      getChangelogItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  const refetch = () => {
    getChangelogItems();
  };

  return (
    <Stack className={classes.groupContainer}>
      {loading !== false ? (
        <div className={classes.loadingContainer}>
          <CircularProgress style={{ color: color.primary }} />
        </div>
      ) : changelogs && changelogs.length === 0 && !changeId ? (
        <center style={{ padding: "2vmax" }}>No change request found</center>
      ) : (
        <>
          {changeId && changeId !== "" ? (
            <ChangeRequestTabs
              changeId={changeId}
              projectDetails={projectDetails}
            />
          ) : (
            <ChangeRequestList
              list={changelogs}
              refetch={refetch}
              projectDetails={projectDetails}
            />
          )}
        </>
      )}
    </Stack>
  );
};

export default Changelog;
